type Listener = (isLoading: boolean) => void;

class LoadingService {
  private activeRequests = 0;
  private listeners: Set<Listener> = new Set();

  subscribe = (listener: Listener): (() => void) => {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  };

  show = () => {
    this.activeRequests++;
    if (this.activeRequests === 1) {
      this.notifyListeners(true);
    }
  };

  hide = () => {
    this.activeRequests--;
    if (this.activeRequests === 0) {
      this.notifyListeners(false);
    }
  };

  private notifyListeners = (isLoading: boolean) => {
    this.listeners.forEach(listener => listener(isLoading));
  };
}

export const loadingService = new LoadingService();
